import { render, staticRenderFns } from "./squadchapterinfomodel.vue?vue&type=template&id=398fde0b"
import script from "./squadchapterinfomodel.vue?vue&type=script&lang=js"
export * from "./squadchapterinfomodel.vue?vue&type=script&lang=js"
import style0 from "./squadchapterinfomodel.vue?vue&type=style&index=0&id=398fde0b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports